import { getPublicEnv } from '@/utils/env';

export const TRIPLA_API_URL = getPublicEnv('NEXT_PUBLIC_TRIPLA_API_URL');
export const CLIENT_SESSION_TRIPLA_URL =
  getPublicEnv('NEXT_PUBLIC_CLIENT_SESSION_TRIPLA_URL');
export const TRIPLA_KEY = process.env.TRIPLA_KEY;
export const TRIPLA_SECRET = process.env.TRIPLA_SECRET;
export const TRIPLA_VERSION = getPublicEnv('NEXT_PUBLIC_TRIPLA_VERSION');
export const TRIPLA_BOOKING_URL = getPublicEnv('NEXT_PUBLIC_TRIPLA_BOOKING_URL');
export const NEXT_PUBLIC_BASE_URL = getPublicEnv('NEXT_PUBLIC_BASE_URL');
export const NODE_ENV = process.env.NODE_ENV;
